import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import { callApi } from "../../utils/api";
import Select from "react-select";
import { Modal, Button, message } from "antd";
import { formatTime24to12 } from "../../common/commonFunctions";

export default function LoginRequestShiftExtension({ show, onClose, onSubmit, loading }) {
    const [extendedStart, setExtendedStart] = useState("");
    const [extendedEnd, setExtendedEnd] = useState("");
    const [extendedEmpId, setExtendedEmpId] = useState("");
    const [reason, setReason] = useState("");
    const [userList, setUserList] = useState([]);
    const [pageDynamic, setPageDynamic] = useState([]);

    const loginShiftType = localStorage.getItem("loginShiftType") || "";
    const parsedLoginShiftType = loginShiftType ? JSON.parse(loginShiftType) : "";

    const currentShiftStart = localStorage.getItem("shiftStartTime") || "";
    const parsedCurrentShiftStart = currentShiftStart ? JSON.parse(currentShiftStart) : "";

    useEffect(() => {
        if (show) {
            getUsers();
            getPageDynamicData();
        } else {
            resetFields();
        }
    }, [show]);

    const resetFields = () => {
        setExtendedStart("");
        setExtendedEnd("");
        setExtendedEmpId("");
        setReason("");
    };

    const getUsers = () => {
        callApi("GET", "user_get.php")
            .then((res) => res.data)
            .then((response) => {
                const formattedUsers = response.data.map((u: any) => ({
                    ...u,
                    label: u.name,
                    value: u.id,
                }));
                setUserList(formattedUsers);
            })
            .catch((err) => console.log(err));
    };

    const getPageDynamicData = () => {
        const user: any = localStorage.getItem("user");
        const userDetails = user ? JSON.parse(user) : "";
        let obj = {
            roleId: userDetails ? userDetails.role_id : null,
            userId: userDetails ? userDetails.userId : null,
            roleType: userDetails ? userDetails.roleType : null,
        };
        callApi("POST", "authenticating_pages_list_new.php", obj)
            .then(res => res.data)
            .then(result => {
                setPageDynamic(result.responseJson.data);
            })
            .catch(err => {
                console.log(err);
            });
    };

    const handleSubmit = () => {
        const user = localStorage.getItem("user");
        const role_label = user ? JSON.parse(user)["role_label"] : "";
        // const isAdmin = ["Admin", "Super Admin"].includes(role_label);
        const isAdminAccess = pageDynamic && pageDynamic.find((page: any) => page.page_name === "Shift List" && page.status == true);

        if (!extendedEmpId && isAdminAccess) {
            return message.warning("Please select employee");
        }
        if (!extendedStart) {
            return message.warning("Please select extended start time");
        }
        if (!extendedEnd) {
            return message.warning("Please select extended end time");
        }
        if (dayjs(extendedEnd, "HH:mm").isBefore(dayjs(extendedStart, "HH:mm"))) {
            return message.error("Extended End Time must be after Extended Start Time.");
        }
        if (!reason.trim()) {
            return message.warning("Please provide a reason");
        }

        onSubmit({
            extendedStart,
            extendedEnd,
            extendedEmpId,
            reason,
        });
    };

    const user = localStorage.getItem("user");
    const role_label = user ? JSON.parse(user)["role_label"] : "";
    // const isAdmin = ["Admin", "Super Admin"].includes(role_label);
    const isAdminAccess = pageDynamic && pageDynamic.find((page: any) => page.page_name === "Shift List" && page.status == true);

    return (
        <Modal
            title="Request Shift Extension"
            visible={show}
            onCancel={onClose}
            footer={null}
            destroyOnClose
        >
            {parsedLoginShiftType != 'extended' &&
                <p>
                    Current shift Start at: <b>{formatTime24to12(parsedCurrentShiftStart)}</b>
                </p>
            }

            {isAdminAccess && (
                <div className="mb-3">
                    <h6>Employee Name</h6>
                    <Select
                        options={userList}
                        value={userList.find((o: any) => o.value === extendedEmpId) || null}
                        onChange={(e) => setExtendedEmpId(e.value)}
                    />
                </div>
            )}

            <div className="mb-3">
                <label>Extended Start Time</label>
                <input
                    type="time"
                    className="form-control"
                    value={extendedStart}
                    onChange={(e) => setExtendedStart(e.target.value)}
                />
            </div>

            <div className="mb-3">
                <label>Extended End Time</label>
                <input
                    type="time"
                    className="form-control"
                    value={extendedEnd}
                    onChange={(e) => setExtendedEnd(e.target.value)}
                />
            </div>

            <div className="mb-3">
                <label>Reason for Extension</label>
                <textarea
                    rows={3}
                    className="form-control"
                    placeholder="Enter reason"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                ></textarea>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button onClick={onClose} style={{ marginRight: 8 }}>
                    Cancel
                </Button>
                <Button type="primary" onClick={handleSubmit} loading={loading}>
                    Submit Request
                </Button>
            </div>
        </Modal>
    );
}
